<template>
  <div class="flex h-full p-6 gap-6">
    <div class="w-full">
      <UserTable @showChat="goToChatPage" />
    </div>
  </div>
</template>

<script>
import UserTable from "@/components/UserTable.vue";
export default {
  name: "DashboardPage",
  components: { UserTable },
  methods: {
    goToChatPage(user) {
      this.$router.push({ name: "Chat", params: { user_id: user.user_id } });
    }
  }
};
</script>
